import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import TextField from "@material-ui/core/TextField";
import RadioGroup from "@material-ui/core/RadioGroup";
import Button from "@material-ui/core/Button";
import Radio from "@material-ui/core/Radio";
import { Dropdown } from "../../../FlowConfigurationInputs";
import RangeInput from "../../../FlowConfigurationInputs/RangeInput/RangeInput";
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";
import "./ModifyDate.css";

export default function ModifyDate({ action, variables, setOpenVariable, fromCondition }) {
  const [refresh, setRefresh] = useState(false);
  const [inputVal, setInputVal] = useState({
    modificationType: { value: "" },
    increaseYear: '',
    decreaseYear: '',
    type: "",
    increaseDay: '',
    decreaseDay: '',
    dayDifferent: { value: '0' },
    yearDifferent: { value: '0' },
    monthDifferent: { value: '0' },
    weekDifferent: { value: '0' },
  });

  const label = "CONTENT.CONFIGURATION-FORM.DATE.MODIFY-DATE.";
  const { t } = useTranslation();

  const options = {
    dropdown: {
      data: [
        {
          value: "day",
          label: label + "DAY",
        },
        {
          value: "month",
          label: label + "MONTH",
        },
        {
          value: "week",
          label: label + "WEEK",
        },
        {
          value: "year",
          label: label + "YEAR",
        },
      ],
      defaultValue: "day",
    },
    dropdownI: {
      data: [
        {
          value: "next",
          label: label + "NEXT",
        },
        {
          value: "previous",
          label: label + "PREVIOUS",
        },
      ],
      defaultValue: "next",
    },
    dropdownFind: {
      data: [
        {
          value: "firstDay",
          label: label + "FIRST-DAY",
        },
        {
          value: "endDay",
          label: label + "END-DAY",
        },
      ],
      defaultValue: "firstDay",
    },
    dropdownTimeUnit: {
      data: [
        {
          value: "week",
          label: label + "WEEK",
        },
        {
          value: "month",
          label: label + "MONTH",
        },
        {
          value: "year",
          label: label + "YEAR",
        },
      ],
      defaultValue: "week",
    },
    dropdownDays: {
      data: [
        {
          value: "1",
          label: label + "MONDAY",
        },
        {
          value: "2",
          label: label + "TUESDAY",
        },
        {
          value: "3",
          label: label + "WEDNESDAY",
        },
        {
          value: "4",
          label: label + "THURSDAY",
        },
        {
          value: "5",
          label: label + "FRIDAY",
        },
        {
          value: "6",
          label: label + "SATURDAY",
        },
        {
          value: "0",
          label: label + "SUNDAY",
        },
      ],
      defaultValue: "1",
    },
  };

  useEffect(() => {
    let datas = {}
    if (!action.fields.modificationType) {
      action.fields.modificationType = { value: "" };
      action.fields.customType = { value: "day" }
    } else {
      datas = {
        modificationType: { value: action.fields.modificationType.value },
        dayDifferent: { value: action.fields.dayDifferent.value },
        yearDifferent: { value: action.fields.yearDifferent.value },
        monthDifferent: { value: action.fields.monthDifferent.value },
        weekDifferent: { value: action.fields.weekDifferent.value },
        customType: { value: action.fields.customType.value }
      }
    }
    if (!action.fields.dayDifferent || action.fields.dayDifferent.value === 0) {
      action.fields.dayDifferent = { value: "" };
    } else {
      const dayDiff = action.fields?.dayDifferent && action.fields.dayDifferent.value != '' ? Number(action.fields.dayDifferent.value) : 0;
      datas.increaseDay = dayDiff > 0 ? dayDiff : '';
      datas.decreaseDay = dayDiff < 0 ? dayDiff : '';
      if (dayDiff != 0) {
        datas.type = dayDiff > 0 ? 'increase' : 'decrease'
      }
    }
    if (!action.fields.yearDifferent || action.fields.yearDifferent.value === 0) {
      action.fields.yearDifferent = { value: 0 };
    } else {
      const yearDiff = action.fields?.yearDifferent && action.fields.yearDifferent.value != '' ? Number(action.fields.yearDifferent.value) : 0;
      datas.increaseYear = yearDiff > 0 ? yearDiff : '';
      datas.decreaseYear = yearDiff < 0 ? yearDiff : '';
      if (yearDiff != 0) {
        datas.type = yearDiff > 0 ? 'increase' : 'decrease'
      }
    }
    if (!action.fields.monthDifferent) {
      action.fields.monthDifferent = { value: 0 };
    }
    if (!action.fields.weekDifferent) {
      action.fields.weekDifferent = { value: 0 };
    }
    setInputVal({
      ...inputVal,
      ...datas
    });
  }, [action, variables, refresh]);

  const handleChange = (event, type, increaseType) => {
    if (type === "radio") {
      let updateDatas = { modificationType: { value: event.target.value } }
      action.fields.modificationType.value = event.target.value;
      if (event.target.value != 'custom') {
        updateDatas = {
          ...updateDatas,
          increaseYear: '',
          decreaseYear: '',
          type: "",
          increaseDay: '',
          decreaseDay: '',
        }
      }
      setInputVal({
        ...inputVal,
        ...updateDatas,
      })
    } else if (type === "text") {
      if (action.fields.customType?.value === "year") {
        if (increaseType === "increase") {
          setInputVal({
            ...inputVal,
            increaseYear: event.target.value,
            decreaseYear: '',
            type: "increase",
          });
        } else if (increaseType === "decrease") {
          setInputVal({
            ...inputVal,
            decreaseYear: event.target.value,
            increaseYear: '',
            type: "decrease",
          });
        }
        action.fields.yearDifferent.value = event.target.value;
      } else if (action.fields.customType?.value === "day") {
        if (increaseType === "increase") {
          setInputVal({
            ...inputVal,
            increaseDay: event.target.value,
            decreaseDay: '',
            type: "increase",
          });
        } else if (increaseType === "decrease") {
          setInputVal({
            ...inputVal,
            decreaseDay: event.target.value,
            increaseDay: '',
            type: "decrease",
          });
        }
        action.fields.dayDifferent.value = event.target.value;
      } else if (
        action.fields.customType?.value === "month" ||
        action.fields.customType?.value === "week"
      ) {
        if (increaseType !== undefined && event.target.value !== undefined) {
          setInputVal({
            ...inputVal,
            [increaseType]: { value: event.target.value },
          });
          action.fields[increaseType].value = event.target.value;
          setRefresh(!refresh)
        }
      }
    }
  };
  
  return (
    <div>
      {
        !fromCondition && <div className="form-element">
          {t(label + "DATE")}
          <VariablePicker action={action} inputName="date"
            variables={variables} setOpenVariable={setOpenVariable}
            filter="date" isRequired />
        </div>
      }
      <div className="form-element">
        <div style={{ color: "#8F94A6", fontSize: 12 }}>
          {t(label + "ADD-MODIFICATION")}
        </div>
        <span style={{ color: "rgba(140, 144, 162, 0.5)", fontSize: 10 }}>
          {t(label + "CUSTOMIZE-REQUIRED")}
        </span>
        <div>
          <RadioGroup
            value={inputVal?.modificationType?.value}
            onChange={(event) => handleChange(event, "radio")}
          >
            <FormControlLabel
              value="custom"
              control={<Radio color="default" size="small" />}
              label="Custom"
            />
            {inputVal?.modificationType?.value?.toLowerCase() === "custom" ? (
              <div className="form-element">
                <Dropdown
                  action={action}
                  inputName="customType"
                  options={options.dropdown}
                  refresh={refresh}
                  setRefresh={setRefresh}
                />
                {action?.fields?.customType?.value === "year" ? (
                  <>
                    <div
                      className="form-element"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        className="convert-date-input"
                        style={{ width: "25%" }}
                      >
                        <TextField
                          id="outlined-basic"
                          placeholder="-1"
                          variant="outlined"
                          value={inputVal?.decreaseYear}
                          type="number"
                          error={inputVal?.decreaseYear > 0}
                          InputProps={{ inputProps: { max: -1 } }}
                          onChange={(event) =>
                            handleChange(event, "text", "decrease")
                          }
                        />
                      </div>
                      <div className="convert-date-input-2">
                        <TextField
                          id="outlined-basic"
                          variant="outlined"
                          value="Year"
                          disabled={true}
                        />
                      </div>
                      <div
                        className="convert-date-input"
                        style={{ width: "25%" }}
                      >
                        <TextField
                          id="outlined-basic"
                          placeholder="+1"
                          variant="outlined"
                          value={inputVal?.increaseYear}
                          type="number"
                          error={inputVal?.increaseYear < 0}
                          InputProps={{ inputProps: { min: 0 } }}
                          onChange={(event) =>
                            handleChange(event, "text", "increase")
                          }
                        />
                      </div>
                    </div>
                  </>
                ) : null}
                {action?.fields?.customType?.value === "day" ? (
                  <>
                    <div
                      className="form-element"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        className="convert-date-input"
                        style={{ width: "25%" }}
                      >
                        <TextField
                          type="number"
                          id="outlined-basic"
                          placeholder="-6"
                          variant="outlined"
                          value={inputVal?.decreaseDay}
                          error={inputVal?.decreaseDay > 0}
                          InputProps={{ inputProps: { max: -1 } }}
                          onChange={(event) =>
                            handleChange(event, "text", "decrease")
                          }
                        />
                      </div>
                      <div className="convert-date-input-2">
                        <TextField
                          id="outlined-basic"
                          variant="outlined"
                          value="Day"
                          style={{ display: "flex" }}
                        />
                      </div>
                      <div
                        className="convert-date-input"
                        style={{ width: "25%" }}
                      >
                        <TextField
                          id="outlined-basic"
                          placeholder="+3"
                          type="number"
                          variant="outlined"
                          value={inputVal?.increaseDay}
                          error={inputVal?.increaseDay < 0}
                          InputProps={{ inputProps: { min: 0 } }}
                          onChange={(event) =>
                            handleChange(event, "text", "increase")
                          }
                        />
                      </div>
                    </div>
                  </>
                ) : null}
                {action?.fields?.customType?.value === "week" ? (
                  <>
                    <div className="form-element">
                      <RangeInput
                        action={action}
                        min={-52}
                        max={52}
                        inputName="weekDifferent"
                        label="Week"
                        refresh={refresh}
                        setRefresh={setRefresh}
                        isRefresh={true}
                      />
                    </div>
                    <div
                      className="form-element"
                      style={{
                        display: "flex",
                        justifyContent: "center"
                      }}
                    >
                      <div className="convert-date-input-2">
                        <Button
                          id="outlined-basic"
                          placeholder="Month"
                          variant="outlined"
                          disabled={true}
                          style={{ marginRight: 30, color: "black", fontSize: 12, height: 32 }}
                        >
                          {t(label + "WEEK")}
                        </Button>
                      </div>
                      <div className="convert-date-input">
                        <TextField
                          id="outlined-basic"
                          placeholder="To, Weeks +1 / -1"
                          variant="outlined"
                          type="number"
                          error={
                            inputVal?.weekDifferent?.value < -52 ||
                            inputVal?.weekDifferent?.value > 52
                          }
                          InputProps={{ inputProps: { min: -52, max: 52 } }}
                          value={inputVal?.weekDifferent?.value}
                          onChange={(event) =>
                            handleChange(event, "text", "weekDifferent")
                          }
                        />
                      </div>
                    </div>
                  </>
                ) : null}
                {action?.fields?.customType?.value === "month" ? (
                  <>
                    <div className="form-element">
                      <RangeInput
                        action={action}
                        min={-12}
                        max={12}
                        inputName="monthDifferent"
                        label="Month"
                        refresh={refresh}
                        setRefresh={setRefresh}
                        isRefresh={true}
                      />
                    </div>
                    <div
                      className="form-element"
                      style={{
                        display: "flex",
                        justifyContent: "center"
                      }}
                    >
                      <div className="convert-date-input-2">
                        <Button
                          id="outlined-basic"
                          placeholder="Month"
                          variant="outlined"
                          disabled={true}
                          style={{ marginRight: 30, color: "black", fontSize: 12, height: 32 }}
                        >
                          {t(label + "MONTH")}
                        </Button>
                      </div>
                      <div className="convert-date-input">
                        <TextField
                          id="outlined-basic"
                          placeholder="To, Month +1 / -1"
                          variant="outlined"
                          type="number"
                          error={
                            inputVal?.monthDifferent?.value < -12 ||
                            inputVal?.monthDifferent?.value > 12
                          }
                          InputProps={{ inputProps: { min: -12, max: 12 } }}
                          value={inputVal?.monthDifferent?.value}
                          onChange={(event) =>
                            handleChange(event, "text", "monthDifferent")
                          }
                        />
                      </div>
                    </div>
                  </>
                ) : null}
              </div>
            ) : null}
            <FormControlLabel
              value="findNext"
              control={<Radio color="default" size="small" />}
              label="Find Next / Previous day of Week"
            />
            {inputVal?.modificationType?.value?.toLowerCase() === "findnext" ? (
              <div className="form-element" style={{ display: "flex" }}>
                <div style={{ width: "45%", marginRight: 10 }}>
                  <Dropdown
                    action={action}
                    inputName="findNext"
                    options={options.dropdownI}
                    refresh={refresh}
                    setRefresh={setRefresh}
                  />
                </div>
                <div style={{ width: "45%" }}>
                  <Dropdown
                    action={action}
                    inputName="day"
                    options={options.dropdownDays}
                    refresh={refresh}
                    setRefresh={setRefresh}
                  />
                </div>
              </div>
            ) : null}
            <FormControlLabel
              value="findStart"
              control={<Radio color="default" size="small" />}
              label="Find Start / End day of Week / Month/Year"
            />
            {inputVal?.modificationType?.value?.toLowerCase() ===
              "findstart" ? (
              <div className="form-element" style={{ display: "flex" }}>
                <div style={{ width: "45%", marginRight: 10 }}>
                  <Dropdown
                    action={action}
                    inputName="findStart"
                    options={options.dropdownFind}
                    refresh={refresh}
                    setRefresh={setRefresh}
                  />
                </div>
                <div style={{ width: "45%" }}>
                  <Dropdown
                    action={action}
                    inputName="timeUnit"
                    options={options.dropdownTimeUnit}
                    refresh={refresh}
                    setRefresh={setRefresh}
                  />
                </div>
              </div>
            ) : null}
          </RadioGroup>
        </div>
        {/* <div className="form-element">
          {t(label + "MODIFICATION-OUTPUT")}
          <div className="convert-date-input" style={{ width: "100%" }}>
            <TextField
              id="outlined-basic"
              variant="outlined"
              style={{ width: "90%" }}
            />
          </div>
        </div> */}
        {
          !fromCondition &&
          <div>
            <div className="form-element">
              <div style={{ borderTop: "1px solid #efefef", width: "100%" }} />
            </div>
            <div className="form-element">
              {t(label + "OUTPUT-VARIABLE")}
              <VariablePicker
                action={action}
                inputName="output"
                variables={variables}
                setOpenVariable={setOpenVariable}
                filter="date"
                isRequired={true}
              />
            </div>
          </div>
        }
      </div>
    </div>
  );
}